import { InventoryQuantityComponent } from './inventory/quantity/quantity.component';
import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ConfirmationService, MessageService } from 'primeng/api';
import { AppMainService } from '../app-main.service';
import { AppMainComponent } from '../app.main.component';
import { LeadService } from '../leads/leadService';
import { ObjectNames,salesOrderModuleObjectNames } from '../shared/constants';
import { PermissionService } from './../service/permission.service';
import { ConfigurationService } from './configurationService';
import { CrmAccountComponent } from './crm/account/acccount.component';
import { CaseComponent } from './crm/case/case.component';
import { CrmContactsComponent } from './crm/contacts/contacts.component';
import { CrmCustomComponent } from './crm/custom/custom.component';
import { CrmOpportunityComponent } from './crm/opportunity';
import { CrmQuestionnaireComponent } from './crm/questionnaire/questionnaire.component';
import { FinanceSetupComponent } from './finance/finance-setup/finance-setup.component';
import { AccountingComponent } from './integration/accounting/accounting.component';
import { BotsComponent } from './integration/bots/bots.component';
import { EcommerceComponent } from './integration/ecommerce/ecommerce.component';
import { EmailComponent } from './integration/email/email.component';
import { LeadGenerationComponent } from './integration/lead-generation/lead-generation.component';
import { ProposalComponent } from './integration/proposal/proposal.component';
import { CustomComponent } from './inventory/custom/custom.component';
import { CustomRuleComponent } from './inventory/custom-rule/custom-rule.component';
import { LocationComponent } from './inventory/location/location.component';
import { OrdersComponent } from './inventory/orders/orders.component';
import { ProductComponent } from './inventory/product/product.component';
import { PurchaseComponent } from './inventory/purchase/purchase.component';
import { SetupComponent } from './inventory/setup/setup.component';
import { SystemNotificationComponent } from './system/notification/notification.component';
import { RoleHierarchyComponent } from './users/role-hierarchy/role-hierarchy.component';
import { ConfigurationUserComponent } from './users/user/user.component';
import { TranslocoService } from '@ngneat/transloco';
import { CrmLeadsComponent } from './crm/leads/leads.component';
import { SmtpComponent } from './integration/smtp/smtp.component';
import { ShippingComponent } from './integration/shipping/shipping.component';
import { TemplateComponent } from './system/template/template.component';
import { GlobalSearchComponent } from './system/global-search/global-search-config.component';
import { PricebookComponent } from './inventory/pricebook/pricebook.component';
import { FsmTerritoryComponent } from './fsm/territory/territory.component';
import { ProfileComponent } from './users/profile/profile.component';
import { VisibilityGroupComponent } from './users/visibility-group/visibility-group.component';
import { SeriesComponent } from './system/series/series.component';
import { ISettingComponent } from './inventory/setting/setting.component';
import { CSettingComponent } from './crm/setting/setting.component';
import { FSettingComponent } from './fsm/setting/setting.component';
import { DuplicateCheckComponent } from './system/duplicate-check/duplicate-check.component';
import { PosComponent } from './integration/pos/pos.component';
import { ConfigurationWorkspaceComponent } from './misc/workspace/workspace.component';
import { ActivityComponent } from './system/activity/activity.component';

@Component({
  selector: 'app-configurations',
  templateUrl: './configurations.component.html',
  styleUrls: ['./configurations.component.css'],
  providers: [ConfirmationService, DatePipe]
})
export class ConfigurationsComponent implements OnInit {

  componentName: any;
  configMenu;
  userSubMenus = [];
  selectedWindow = "";
  ActivityModule = false;
  oppTargetStages = [];
  oppSourceStages = [];
  selectedAccountInfoLabels = [];
  selectedAccountBusinessLabels = []
  checkboxConfig: boolean = true;

  originalOppTargetStages = [];


  isDisabledFieldData = true;
  ErrorMessage = "";
  ErrorMessageName = "";

  // menu permissions
  companyDetailsMenuPermission;
  privacyMenuPermission;
  roleMenuPermission;
  userMenuPermission;
  notificationMenuPermission;
  templateMenuPermission;
  globalMenuPermission;
  savedMenuPermission;
  duplicateCheckMenuPermission;
  seriesMenuPermission;
  mobileMenuPermission;
  webMenuPermission
  accountMenuPermission;
  contactMenuPermission;
  territoryMenuPermission;
  questionnaireMenuPermission;
  gaolsMenuPermission;
  cSettingMenuPermission;
  leadMenuPermission;
  opportunityMenuPermission;
  caseMenuPermission;
  crmCustomMenuPermission;
  fSettingMenuPermission;
  financeSetupMenuPermission;
  productMenuPermission;
  pricebookMenuPermission;
  locationMenuPermission;
  inventorySetupMenuPermission;
  iSettingMenuPermission;
  financeMenuPermission;
  quantityMenuPermission;
  orderMenuPermission;
  purchaseMenuPermission;
  customersMenuPermission;
  customMenuPermission;
  customRuleMenuPermission;
  workspaceMenuPermission;
  allCustomPickvalues: any;
  countryIdMulti: any;

  filterValues = []
  filterValuesLists = []
  ruleLists = [];

  configMenuTranslate = {
    Menu_Title: "",
    User: "",
    System: "",
    CRM: "",
    FSM:"",
    Finance: "",
    Inventory: "",
    Integrations: "",
    Privacy: "",
    Role: "",
    Mobile: "",
    Web: "",
    Notification: "",
    Template:"",
    Account: "",
    Contacts: "",
    Territory: "",
    Questionnaire: "",
    Goals: "",
    Leads: "",
    Opportunity: "",
    Cases: "",
    Custom: "",
    MISC: "",
  }

  //3rd party integration permission
  accountingMenuPermission;
  botsMenuPermission;
  calendarMenuPermission;
  emailMenuPermission;
  leadGenerationMenuPermission;
  proposalMenuPermission;
  posMenuPermission;
  ecommerceMenuPermission;
  smtpMenuPermission;
  shippingMenuPermission;

  constructor(
    private service: ConfigurationService,
    public app: AppMainComponent,
    private appMainService: AppMainService,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    public datepipe: DatePipe,
    private leadService: LeadService,
    private permissionService: PermissionService,
    private translocoService: TranslocoService,
  ) {
  }

  ngOnInit() {
    const currentUrl = window.location.href;
    // start: menu permissions
    const userPermissions = this.permissionService.getPemrissionData();
    const companyDetailsUserPermission = userPermissions.find(obj => obj.objectName === ObjectNames.COMPANY_DETAILS);
    this.companyDetailsMenuPermission = companyDetailsUserPermission ? (companyDetailsUserPermission.permissions.find(obj => obj.statusId == 1) ? true : false) : false;

    const privacyUserPermission = userPermissions.find(obj => obj.objectName === ObjectNames.PRIVACY);
    this.privacyMenuPermission = privacyUserPermission ? (privacyUserPermission.permissions.find(obj => obj.statusId == 1) ? true : true) : false;

    const roleUerPermission = userPermissions.find(obj => obj.objectName === ObjectNames.ROLE);
    this.roleMenuPermission = roleUerPermission ? (roleUerPermission.permissions.find(obj => obj.statusId == 1) ? true : false) : false;

    const userUerPermission = userPermissions.find(obj => obj.objectName === ObjectNames.USER);
    this.userMenuPermission = userUerPermission ? (userUerPermission.permissions.find(obj => obj.statusId == 1) ? true : false) : false;

    const mobileUerPermission = userPermissions.find(obj => obj.objectName === ObjectNames.MOBILE_APP);
    this.mobileMenuPermission = mobileUerPermission ? (mobileUerPermission.permissions.find(obj => obj.statusId == 1) ? true : false) : false;

    const webUerPermission = userPermissions.find(obj => obj.objectName === ObjectNames.WEB);
    this.webMenuPermission = webUerPermission ? (webUerPermission.permissions.find(obj => obj.statusId == 1) ? true : false) : false;

    const notficationUerPermission = userPermissions.find(obj => obj.objectName === ObjectNames.NOTIFICATION);
    this.notificationMenuPermission = notficationUerPermission ? (notficationUerPermission.permissions.find(obj => obj.statusId == 1) ? true : false) : false;

    const templateUerPermission = userPermissions.find(obj => obj.objectName === ObjectNames.TEMPLATE);
    this.templateMenuPermission = notficationUerPermission ? (notficationUerPermission.permissions.find(obj => obj.statusId == 1) ? true : false) : false;

    const globalPermission = userPermissions.find(obj => obj.objectName === ObjectNames.GLOBAL);
    this.globalMenuPermission = notficationUerPermission ? (notficationUerPermission.permissions.find(obj => obj.statusId == 1) ? true : false) : false;

    const savedPermission = userPermissions.find(obj => obj.objectName === ObjectNames.SAVED);
    this.savedMenuPermission = notficationUerPermission ? (notficationUerPermission.permissions.find(obj => obj.statusId == 1) ? true : false) : false;

    const duplicateCheckPermission = userPermissions.find(obj => obj.objectName === ObjectNames.DUPLICATE);
    this.duplicateCheckMenuPermission = notficationUerPermission ? (notficationUerPermission.permissions.find(obj => obj.statusId == 1) ? true : false) : false;

    const seriesPermission = userPermissions.find(obj => obj.objectName === ObjectNames.SERIES);

    this.seriesMenuPermission = notficationUerPermission ? (notficationUerPermission.permissions.find(obj => obj.statusId == 1) ? true : false) : false;

    const accountUerPermission = userPermissions.find(obj => obj.objectName === ObjectNames.ACCOUNT);
    this.accountMenuPermission = accountUerPermission ? (accountUerPermission.permissions.find(obj => obj.statusId == 1) ? true : false) : false;

    const contactUerPermission = userPermissions.find(obj => obj.objectName === ObjectNames.CONTACT);
    this.contactMenuPermission = contactUerPermission ? (contactUerPermission.permissions.find(obj => obj.statusId == 1) ? true : false) : false;

    const territoryUerPermission = userPermissions.find(obj => obj.objectName === ObjectNames.TERRITORY_CONFIGURATION);
    this.territoryMenuPermission = territoryUerPermission ? (territoryUerPermission.permissions.find(obj => obj.statusId == 1) ? true : false) : false;
   
    const workspaceMenuPermission = userPermissions.find(obj => obj.objectName === ObjectNames.WORKSPACES);
    this.workspaceMenuPermission = workspaceMenuPermission
      ? workspaceMenuPermission.permissions.some(obj => obj.statusId === 1)
      : false;
   
    const questionnaireUerPermission = userPermissions.find(obj => obj.objectName === ObjectNames.QUESTIONNAIRE);
    this.questionnaireMenuPermission = questionnaireUerPermission ? (questionnaireUerPermission.permissions.find(obj => obj.statusId == 1) ? true : false) : false;

    const gaolsUserPermission = userPermissions.find(obj => obj.objectName === ObjectNames.GOAL);
    this.gaolsMenuPermission = gaolsUserPermission ? (gaolsUserPermission.permissions.find(obj => obj.statusId == 1) ? true : false) : false;

    const leadUserPermission = userPermissions.find(obj => obj.objectName === ObjectNames.LEAD);
    this.leadMenuPermission = leadUserPermission ? (leadUserPermission.permissions.find(obj => obj.statusId == 1) ? true : false) : false;

    const opportunityUserPermission = userPermissions.find(obj => obj.objectName === ObjectNames.OPPORTUNITY);
    this.opportunityMenuPermission = opportunityUserPermission ? (opportunityUserPermission.permissions.find(obj => obj.statusId == 1) ? true : false) : false;

    const casesUserPermission = userPermissions.find(obj => obj.objectName === ObjectNames.CASES);
    this.caseMenuPermission = casesUserPermission ? (casesUserPermission.permissions.find(obj => obj.statusId == 1) ? true : false) : false;

    this.cSettingMenuPermission = this.leadMenuPermission || this.accountMenuPermission || this.contactMenuPermission || this.userMenuPermission;

    const crmCustomUserPermission = userPermissions.find(obj => obj.objectName === ObjectNames.CRM_CUSTOM);
    this.crmCustomMenuPermission = crmCustomUserPermission ? (crmCustomUserPermission.permissions.find(obj => obj.statusId == 1) ? true : false) : false;

    const fSettingUserPermission = userPermissions.find(obj => obj.objectName === ObjectNames.F_SETTING);
    this.fSettingMenuPermission = fSettingUserPermission ? (fSettingUserPermission.permissions.find(obj => obj.statusId == 1) ? true : false) : false;

    const financeSetupUserPermission = userPermissions.find(obj => obj.objectName === ObjectNames.FINANCE);
    this.financeSetupMenuPermission = financeSetupUserPermission ? (financeSetupUserPermission.permissions.find(obj => obj.statusId == 1) ? true : false) : false;

    const productUserPermission = userPermissions.find(obj => obj.objectName === ObjectNames.PRODUCT);
    this.productMenuPermission = productUserPermission ? (productUserPermission.permissions.find(obj => obj.statusId == 1) ? true : false) : false;

    const pricebookUserPermission = userPermissions.find(obj => obj.objectName === ObjectNames.PRODUCT);
    this.pricebookMenuPermission = productUserPermission ? (productUserPermission.permissions.find(obj => obj.statusId == 1) ? true : false) : false;

    const locationUserPermission = userPermissions.find(obj => obj.objectName === ObjectNames.WAREHOUSE);
    this.locationMenuPermission = locationUserPermission ? (locationUserPermission.permissions.find(obj => obj.statusId == 1) ? true : false) : false;

    const inventorySetupUserPermission = userPermissions.find(obj => obj.objectName === ObjectNames.INVENTORY_SETUP);
    this.inventorySetupMenuPermission = inventorySetupUserPermission ? (inventorySetupUserPermission.permissions.find(obj => obj.statusId == 1) ? true : false) : false;

    const iSettingUserPermission = userPermissions.find(obj => obj.objectName === ObjectNames.I_SETTING);
    this.iSettingMenuPermission = inventorySetupUserPermission ? (inventorySetupUserPermission.permissions.find(obj => obj.statusId == 1) ? true : false) : false;

    const quantityUserPermission = userPermissions.find(obj => obj.objectName === ObjectNames.QUANTITY);
    this.quantityMenuPermission = quantityUserPermission ? (quantityUserPermission.permissions.find(obj => obj.statusId == 1) ? true : false) : false;

    //const orderUserPermission = userPermissions.find(obj => obj.objectName === ObjectNames.ORDER);
    this.orderMenuPermission = userPermissions?.some(obj => salesOrderModuleObjectNames?.includes(obj.objectName) && obj.permissions?.some(permission => permission.statusId === 1));
    //this.orderMenuPermission = orderUserPermission ? (orderUserPermission.permissions.find(obj => obj.statusId == 1) ? true : false) : false;

    const purchaseUserPermission = userPermissions.find(obj => obj.objectName === ObjectNames.PURCHASE);
    this.purchaseMenuPermission = purchaseUserPermission ? (purchaseUserPermission.permissions.find(obj => obj.statusId == 1) ? true : false) : false;

    const customersUserPermission = userPermissions.find(obj => obj.objectName === ObjectNames.CUSTOMERS);
    this.customersMenuPermission = purchaseUserPermission ? (purchaseUserPermission.permissions.find(obj => obj.statusId == 1) ? true : false) : false;

    const customFieldsPermission = userPermissions.find(obj => obj.objectName === ObjectNames.CUSTOM);
    this.customMenuPermission = customFieldsPermission ? (customFieldsPermission.permissions.find(obj => obj.statusId == 1) ? true : false) : false;

    const customRulePermission = userPermissions.find(obj => obj.objectName === ObjectNames.CUSTOM_RULES);
    this.customRuleMenuPermission = customRulePermission ? (customRulePermission.permissions.find(obj => obj.statusId == 1) ? true : false) : false;

    //3rd party integration permissions
    const accountingUserPermission = userPermissions.find(obj => obj.objectName === ObjectNames.ACCOUNTING);
    this.accountingMenuPermission = accountingUserPermission ? (accountingUserPermission.permissions.find(obj => obj.statusId == 1) ? true : false) : false;

    const campaignPermission = userPermissions.find(obj => obj.objectName === ObjectNames.CAMPAIGN);
    this.botsMenuPermission = campaignPermission ? (campaignPermission.permissions.find(obj => obj.statusId == 1) ? true : false) : false;

    const calendarUserPermission = userPermissions.find(obj => obj.objectName === ObjectNames.CALENDAR);
    this.calendarMenuPermission = purchaseUserPermission ? (purchaseUserPermission.permissions.find(obj => obj.statusId == 1) ? true : false) : false;

    const emailUserPermission = userPermissions.find(obj => obj.objectName === ObjectNames.EMAIL);
    this.emailMenuPermission = purchaseUserPermission ? (purchaseUserPermission.permissions.find(obj => obj.statusId == 1) ? true : false) : false;

    const leadGenerationUserPermission = userPermissions.find(obj => obj.objectName === ObjectNames.LEADGENERATION);
    this.leadGenerationMenuPermission = purchaseUserPermission ? (purchaseUserPermission.permissions.find(obj => obj.statusId == 1) ? true : false) : false;

    const proposalUserPermission = userPermissions.find(obj => obj.objectName === ObjectNames.PROPOSAL);
    this.proposalMenuPermission = purchaseUserPermission ? (purchaseUserPermission.permissions.find(obj => obj.statusId == 1) ? true : false) : false;

    const isPointOfsale = userPermissions.some(obj => obj.objectName == ObjectNames.pointOfSale);
    if(isPointOfsale){
    const posUserPermission = userPermissions.find(obj => obj.objectName === ObjectNames.POS);
    this.posMenuPermission = purchaseUserPermission ? (purchaseUserPermission.permissions.find(obj => obj.statusId == 1) ? true : false) : false;
    };

    const ecommerceUserPermission = userPermissions.find(obj => obj.objectName === ObjectNames.ECOMMERCE);
    this.ecommerceMenuPermission = purchaseUserPermission ? (purchaseUserPermission.permissions.find(obj => obj.statusId == 1) ? true : false) : false;

    const smtpUserPermission = userPermissions.find(obj => obj.objectName === ObjectNames.VendorSMTPRegistration);
    this.smtpMenuPermission = smtpUserPermission ? (smtpUserPermission.permissions.find(obj => obj.statusId == 1) ? true : false) : false;

    const shippingUserPermission = userPermissions.find(obj => obj.objectName === ObjectNames.SMTP);
    this.shippingMenuPermission = purchaseUserPermission ? (purchaseUserPermission.permissions.find(obj => obj.statusId == 1) ? true : false) : false;

    // end: menu permissions
    this.getTranslatedValues();
  }

  getTranslatedValues() {
    this.translocoService.selectTranslate('Configuration.Menu_Title').subscribe((data) => {
      this.configMenuTranslate.Menu_Title = data;
    });
    this.translocoService.selectTranslate('Configuration.Menu.User').subscribe((data) => {
      this.configMenuTranslate.User = data;
    });
    this.translocoService.selectTranslate('Configuration.Menu.System').subscribe((data) => {
      this.configMenuTranslate.System = data;
    });
    this.translocoService.selectTranslate('Configuration.Menu.CRM').subscribe((data) => {
      this.configMenuTranslate.CRM = data;
    });
    this.translocoService.selectTranslate('FSM').subscribe((data) => {
      this.configMenuTranslate.FSM = data;
    });
    this.translocoService.selectTranslate('Configuration.Menu.Finance').subscribe((data) => {
      this.configMenuTranslate.Finance = data;
    });
    this.translocoService.selectTranslate('Configuration.Menu.Inventory').subscribe((data) => {
      this.configMenuTranslate.Inventory = data;
    });
    this.translocoService.selectTranslate('Configuration.User.Privacy').subscribe((data) => {
      this.configMenuTranslate.Privacy = data;
    });
    this.translocoService.selectTranslate('Configuration.User.Role').subscribe((data) => {
      this.configMenuTranslate.Role = data;
    });
    this.translocoService.selectTranslate('Configuration.System.Mobile').subscribe((data) => {
      this.configMenuTranslate.Mobile = data;
    });
    this.translocoService.selectTranslate('Configuration.System.Web').subscribe((data) => {
      this.configMenuTranslate.Web = data;
    });
    this.translocoService.selectTranslate('Configuration.System.Notification').subscribe((data) => {
      this.configMenuTranslate.Notification = data;
    });
    this.translocoService.selectTranslate('Configuration.System.Template').subscribe((data) => {
      this.configMenuTranslate.Template = data;
    });
    this.translocoService.selectTranslate('Configuration.CRM.Account').subscribe((data) => {
      this.configMenuTranslate.Account = data;
    });
    this.translocoService.selectTranslate('Configuration.CRM.Contacts').subscribe((data) => {
      this.configMenuTranslate.Contacts = data;
    });
    this.translocoService.selectTranslate('Configuration.CRM.Territory').subscribe((data) => {
      this.configMenuTranslate.Territory = data;
    });
    this.translocoService.selectTranslate('Configuration.CRM.Questionnaire').subscribe((data) => {
      this.configMenuTranslate.Questionnaire = data;
    });
    this.translocoService.selectTranslate('Configuration.CRM.Goals').subscribe((data) => {
      this.configMenuTranslate.Goals = data;
    });
    this.translocoService.selectTranslate('Configuration.CRM.Leads').subscribe((data) => {
      this.configMenuTranslate.Leads = data;
    });
    this.translocoService.selectTranslate('Configuration.CRM.Opportunity').subscribe((data) => {
      this.configMenuTranslate.Opportunity = data;
    });
    this.translocoService.selectTranslate('Configuration.CRM.Cases').subscribe((data) => {
      this.configMenuTranslate.Cases = data;
    });
    this.translocoService.selectTranslate('Configuration.CRM.Custom').subscribe((data) => {
      this.configMenuTranslate.Custom = data;
    });
    this.translocoService.selectTranslate('Configuration.Menu.Integrations').subscribe((data) => {
      this.configMenuTranslate.Integrations = data;
      this.buildConfigMenu();
    });
    this.translocoService.selectTranslate('Misc').subscribe((data) => {
      this.configMenuTranslate.MISC = data;
      this.buildConfigMenu();
    });
  }


  system = false;
  userm = false;
  company = false;
  marketplace = false;
  module = false;
  inventory = false;
  finance = false;
  integration = false;
  fsm = false;
  misc = false;

  buildConfigMenu() {
    const menuTitle = this.configMenuTranslate.Menu_Title;
    let company = this.selectedWindow == 'company' ? `<span class="selectedConfigMenuItem">${menuTitle}</span>` : `${menuTitle}`;
    let mobile = this.selectedWindow == 'mobile' ? `<span class="selectedConfigMenuItem">${this.configMenuTranslate.Mobile}</span>` : `${this.configMenuTranslate.Mobile}`;
    let web = this.selectedWindow == 'web' ? `<span class="selectedConfigMenuItem">${this.configMenuTranslate.Web}</span>` : `${this.configMenuTranslate.Web}`;
    let notification = this.selectedWindow == 'notification' ? `<span class="selectedConfigMenuItem">${this.configMenuTranslate.Notification}</span>` : `${this.configMenuTranslate.Notification}`;
    let template = this.selectedWindow == 'template' ? `<span class="selectedConfigMenuItem">Template</span>` : 'Template';
    let global = this.selectedWindow == 'global' ? `<span class="selectedConfigMenuItem">Global Search</span>` : 'Global Search';
    let saved = this.selectedWindow == 'saved' ? `<span class="selectedConfigMenuItem">Saved Search</span>` : 'Saved Search';
    // let duplicateCheck = this.selectedWindow == 'duplicate' ? `<span class="selectedConfigMenuItem">Duplicate Check</span>` : 'Duplicate Check';
    let series = this.selectedWindow == 'series' ? `<span class="selectedConfigMenuItem">No. Series</span>` : 'No. Series';
    let activity = this.selectedWindow == 'activity' ? `<span class="selectedConfigMenuItem">Activity</span>` : 'Activity';

    /* let permission = this.selectedWindow == 'permission' ? '<span class="selectedConfigMenuItem">Permission</span>' : 'Permission'; */
    let privacy = this.selectedWindow == 'privacy' ? `<span class="selectedConfigMenuItem">${this.configMenuTranslate.Privacy}</span>` : `${this.configMenuTranslate.Privacy}`;
    let user = this.selectedWindow == 'user' ? `<span class="selectedConfigMenuItem">${this.configMenuTranslate.User}</span>` : `${this.configMenuTranslate.User}`;
    let role = this.selectedWindow == 'role' ? `<span class="selectedConfigMenuItem">${this.configMenuTranslate.Role}</span>` : `${this.configMenuTranslate.Role}`;
    let roleHierarchy = this.selectedWindow == 'roleHierarchy' ? '<span class="selectedConfigMenuItem">Role Hierarchy</span>' : 'Role Hierarchy';
    let profile = this.selectedWindow == 'profile' ? '<span class="selectedConfigMenuItem">Profile</span>' : 'Profile';
    let visibility = this.selectedWindow == 'visibility' ? '<span class="selectedConfigMenuItem">User Visibility</span>' : 'User Visibility';
    let sample1 = this.selectedWindow == 'sample1' ? '<span class="selectedConfigMenuItem">Sample 1</span>' : 'Sample 1';
    let sample2 = this.selectedWindow == 'sample2' ? '<span class="selectedConfigMenuItem">Sample 2</span>' : 'Sample 2';

    //crm
    let accountModule = this.selectedWindow == 'accountModule' ? `<span class="selectedConfigMenuItem">Accounts</span>` : 'Accounts';
    let activityModule = this.selectedWindow == 'activityModule' ? '<span class="selectedConfigMenuItem">Activity</span>' : 'Activity';
    let casesModule = this.selectedWindow == 'casesModule' ? `<span class="selectedConfigMenuItem">${this.configMenuTranslate.Cases}</span>` : `${this.configMenuTranslate.Cases}`;
    let crmCustomModule = this.selectedWindow == 'crmCustomModule' ? `<span class="selectedConfigMenuItem">${this.configMenuTranslate.Custom}</span>` : `${this.configMenuTranslate.Custom}`;
    let contactsModule = this.selectedWindow == 'contactsModule' ? `<span class="selectedConfigMenuItem">${this.configMenuTranslate.Contacts}</span>` : `${this.configMenuTranslate.Contacts}`;
    let goalsModule = this.selectedWindow == 'goalsModule' ? `<span class="selectedConfigMenuItem">Sales Quota</span>` : 'Sales Quota';
    let leadModule = this.selectedWindow == 'leadModule' ? `<span class="selectedConfigMenuItem">${this.configMenuTranslate.Leads}</span>` : `${this.configMenuTranslate.Leads}`;
    let opportunityModule = this.selectedWindow == 'opportunityModule' ? `<span class="selectedConfigMenuItem">${this.configMenuTranslate.Opportunity}</span>` : `${this.configMenuTranslate.Opportunity}`;
    let Questionnaire = this.selectedWindow == 'Questionnaire' ? `<span class="selectedConfigMenuItem">${this.configMenuTranslate.Questionnaire}</span>` : `${this.configMenuTranslate.Questionnaire}`;
    let cSettingModule = this.selectedWindow == 'cSettingModule' ? '<span class="selectedConfigMenuItem">C-Settings</span>' : 'C-Settings';

    //fsm
    let territoryManagement = this.selectedWindow == 'territoryManagement' ? `<span class="selectedConfigMenuItem">${this.configMenuTranslate.Territory}</span>` : `${this.configMenuTranslate.Territory}`;
    let fSettingModule = this.selectedWindow == 'fSettingModule' ? '<span class="selectedConfigMenuItem">F-Settings</span>' : 'F-Settings';

    //Misc
    let workspaceModule = this.selectedWindow == 'workspaceModule' ? '<span class="selectedConfigMenuItem">Workspace</span>' : 'Workspace';

    //inventory
    let productModule = this.selectedWindow == 'productModule' ? '<span class="selectedConfigMenuItem">Products</span>' : 'Products';
    let pricebookModule = this.selectedWindow == 'pricebookModule' ? '<span class="selectedConfigMenuItem">Pricebooks</span>' : 'Pricebooks';
    let locationModule = this.selectedWindow == 'locationModule' ? '<span class="selectedConfigMenuItem">Locations</span>' : 'Locations';
    let setupModule = this.selectedWindow == 'setupModule' ? '<span class="selectedConfigMenuItem">Set up</span>' : 'Set up';
    let quantityModule = this.selectedWindow == 'quantityModule' ? '<span class="selectedConfigMenuItem">Quantity</span>' : 'Quantity';
    let purchaseModule = this.selectedWindow == 'purchaseModule' ? '<span class="selectedConfigMenuItem">Purchases</span>' : 'Purchases';
    let ordersModule = this.selectedWindow == 'ordersModule' ? '<span class="selectedConfigMenuItem">Sales</span>' : 'Sales';
    let customModule = this.selectedWindow == 'customModule' ? '<span class="selectedConfigMenuItem">Custom Fields</span>' : 'Custom Fields';
    let customRuleModule = this.selectedWindow == 'customRuleModule' ? '<span class="selectedConfigMenuItem">Custom Rules</span>' : 'Custom Rules';
    let customersModule = this.selectedWindow == 'customersModule' ? '<span class="selectedConfigMenuItem">Customers</span>' : 'Customers';
    let financeSetupModule = this.selectedWindow == 'financeSetupModule' ? '<span class="selectedConfigMenuItem">Set up</span>' : 'Set up';
    let iSettingModule = this.selectedWindow == 'iSettingModule' ? '<span class="selectedConfigMenuItem">I-Settings</span>' : 'I-Settings';

    //3rd party integration
    let accountingModule = this.selectedWindow == 'accountingModule' ? '<span class="selectedConfigMenuItem">Accounting & Invoicing</span>' : 'Accounting & Invoicing';
    let botsModule = this.selectedWindow == 'botsModule' ? '<span class="selectedConfigMenuItem">Bots & Messaging</span>' : 'Bots & Messaging';
    let calendarModule = this.selectedWindow == 'calendarModule' ? '<span class="selectedConfigMenuItem">Contact & Calendar sync</span>' : 'Contact & Calendar sync';
    let emailModule = this.selectedWindow == 'emailModule' ? '<span class="selectedConfigMenuItem">Email Marketing</span>' : 'Email Marketing';
    let leadGenerationModule = this.selectedWindow == 'leadGenerationModule' ? '<span class="selectedConfigMenuItem">Lead Generation</span>' : 'Lead Generation';
    let proposalModule = this.selectedWindow == 'proposalModule' ? '<span class="selectedConfigMenuItem">Proposals & Contracts</span>' : 'Proposals & Contracts';
    let ecommerceModule = this.selectedWindow == 'ecommerceModule' ? '<span class="selectedConfigMenuItem">Ecommerce</span>' : 'Ecommerce';
    let smtpModule = this.selectedWindow == 'smtpModule' ? '<span class="selectedConfigMenuItem">SMTP</span>' : 'SMTP';
    let shipModule = this.selectedWindow == 'shipModule' ? '<span class="selectedConfigMenuItem">Shipping</span>' : 'Shipping';
    let posModule = this.selectedWindow == 'posModule' ? '<span class="selectedConfigMenuItem">Point of Sale</span>' : 'Point of Sale';

    this.configMenu = [
      {
        label: this.configMenuTranslate.User,
        expanded: this.userm,
        items: []
      },
      {
        label: this.configMenuTranslate.System,
        expanded: this.system,
        items: []
      },

      {
        label: this.configMenuTranslate.CRM,
        expanded: this.module,
        items: [
          // {
          //   label: activityModule,
          //   escape: false,
          //   command: () => {
          //     this.system = false;
          //     this.userm = false;
          //     this.marketplace = false;
          //     this.module = true;
          //     this.inventory = false;
          //     this.selectedWindow = 'activityModule';k
          //     this.ActivityModule = true;
          //     this.buildConfigMenu();
          //   }
          // },
        ]
      },
      {
        label: this.configMenuTranslate.FSM,
        expanded: this.fsm,
        items: []
      },
      {
        label: this.configMenuTranslate.Finance,
        expanded: this.finance,
        items: []
      },
      {
        label: this.configMenuTranslate.MISC,
        expanded: this.misc,
        items: []
      },
      {
        label: this.configMenuTranslate.Inventory,
        expanded: this.inventory,
        items: []
      },
      {
        label: this.configMenuTranslate.Integrations,
        expanded: this.integration,
        items: []
      },
    ];

    if (this.companyDetailsMenuPermission) {
      this.configMenu.unshift({
        label: company,
        escape: false,
        command: () => {
          this.system = false;
          this.userm = false;
          this.company = true;
          this.marketplace = false;
          this.module = false;
          this.inventory = false;
          this.integration = false;
          this.misc = false;
          this.selectedWindow = 'company';
          this.buildConfigMenu();
        }
      })
    }
    this.configMenu.map((obj, index) => {

      if (obj.label == "User" || obj.label == "Utilisateur" || obj.label == "用户") {
        if (this.userMenuPermission) {
          obj.items.push({
            label: user,
            escape: false,
            command: () => {
              this.system = false;
              this.userm = true;
              this.marketplace = false;
              this.module = false;
              this.fsm = false;
              this.inventory = false;
              this.integration = false;
              this.misc = false;
              this.selectedWindow = 'user';
              this.componentName = ConfigurationUserComponent;
              this.buildConfigMenu();
            }
          })
        }

        if (this.roleMenuPermission) {
          obj.items.push({
            label: roleHierarchy,
            escape: false,
            command: () => {
              this.system = false;
              this.userm = true;
              this.marketplace = false;
              this.module = false;
              this.fsm = false;
              this.inventory = false;
              this.integration = false;
              this.misc = false;
              this.selectedWindow = 'roleHierarchy';
              this.componentName = RoleHierarchyComponent;
              this.buildConfigMenu();
            }
          })
        }

        if (this.userMenuPermission) {
          obj.items.push({
            label: profile,
            escape: false,
            command: () => {
              this.system = false;
              this.userm = true;
              this.marketplace = false;
              this.module = false;
              this.fsm = false;
              this.inventory = false;
              this.integration = false;
              this.misc = false;
              this.selectedWindow = 'profile';
              this.componentName = ProfileComponent;
              this.buildConfigMenu();
            }
          })
        }

        if (this.roleMenuPermission) {
          obj.items.push({
            label: visibility,
            escape: false,
            command: () => {
              this.system = false;
              this.userm = true;
              this.marketplace = false;
              this.module = false;
              this.fsm = false;
              this.inventory = false;
              this.integration = false;
              this.misc = false;
              this.selectedWindow = 'visibility';
              this.componentName = VisibilityGroupComponent;
              this.buildConfigMenu();
            }
          })
        }


      }

      if (obj.label == "System" || obj.label == "Système" || obj.label == "系统") {
  
        if (this.notificationMenuPermission) {
          obj.items.push({
            label: notification,
            escape: false,
            command: () => {
              this.system = true;
              this.userm = false;
              this.marketplace = false;
              this.module = false;
              this.fsm = false;
              this.inventory = false;
              this.integration = false;
              this.misc = false;
              this.selectedWindow = 'notification';
              this.componentName = SystemNotificationComponent;
              this.buildConfigMenu();
            }
          })
        }

        if (this.templateMenuPermission) {
          obj.items.push({
            label: template,
            escape: false,
            command: () => {
              this.system = true;
              this.userm = false;
              this.marketplace = false;
              this.module = false;
              this.fsm = false;
              this.inventory = false;
              this.misc = false;
              this.integration = false;
              this.selectedWindow = 'template';
              this.componentName = TemplateComponent;
              this.buildConfigMenu();
            }
          })
        }

        if (this.globalMenuPermission) {
          obj.items.push({
            label: global,
            escape: false,
            command: () => {
              this.system = true;
              this.userm = false;
              this.marketplace = false;
              this.module = false;
              this.fsm = false;
              this.misc = false;
              this.inventory = false;
              this.integration = false;
              this.selectedWindow = 'global';
              this.componentName = GlobalSearchComponent;
              this.buildConfigMenu();
            }
          })
        }

        // if (this.duplicateCheckMenuPermission) {
        //   obj.items.push({
        //     label: duplicateCheck,
        //     escape: false,
        //     command: () => {
        //       this.system = true;
        //       this.userm = false;
        //       this.marketplace = false;
        //       this.module = false;
        //       this.fsm = false;
        //       this.inventory = false;
        //       this.misc = false;
        //       this.integration = false;
        //       this.selectedWindow = 'duplicate';
        //       this.componentName = DuplicateCheckComponent;
        //       this.buildConfigMenu();
        //     }
        //   })
        // }

        if (this.seriesMenuPermission) {
          obj.items.push({
            label: series,
            escape: false,
            command: () => {
              this.system = true;
              this.userm = false;
              this.marketplace = false;
              this.module = false;
              this.fsm = false;
              this.inventory = false;
              this.integration = false;
              this.misc = false;
              this.selectedWindow = 'series';
              this.componentName = SeriesComponent;
              this.buildConfigMenu();
            }
          })
        }

          obj.items.push({
            label: activity,
            escape: false,
            command: () => {
              this.system = true;
              this.userm = false;
              this.marketplace = false;
              this.module = false;
              this.fsm = false;
              this.inventory = false;
              this.integration = false;
              this.misc = false;
              this.selectedWindow = 'activity';
              this.componentName = ActivityComponent;
              this.buildConfigMenu();
            }
          })

      }

      if (obj.label == "CRM" || obj.label == "GRC" || obj.label == "客户关系管理") {

        if (this.accountMenuPermission) {
          obj.items.push({
            label: accountModule,
            escape: false,
            command: () => {
              this.system = false;
              this.userm = false;
              this.marketplace = false;
              this.module = true;
              this.fsm = false;
              this.inventory = false;
              this.finance = false;
              this.integration = false;
              this.misc = false;
              this.selectedWindow = 'accountModule';
              this.componentName = CrmAccountComponent;
              this.buildConfigMenu();
            }
          })
        }

        if (this.caseMenuPermission) {
          obj.items.push({
            label: casesModule,
            escape: false,
            command: () => {
              this.system = false;
              this.userm = false;
              this.marketplace = false;
              this.module = true;
              this.fsm = false;
              this.inventory = false;
              this.integration = false;
              this.misc = false;
              this.selectedWindow = 'casesModule';
              this.componentName = CaseComponent;
              this.buildConfigMenu();
            }
          });
        }

        if (this.contactMenuPermission) {
          obj.items.push({
            label: contactsModule,
            escape: false,
            command: () => {
              this.system = false;
              this.userm = false;
              this.marketplace = false;
              this.module = true;
              this.fsm = false;
              this.inventory = false;
              this.misc = false;
              this.integration = false;
              this.selectedWindow = 'contactsModule';
              this.componentName = CrmContactsComponent;
              this.buildConfigMenu();
            }
          })
        }

        if (this.crmCustomMenuPermission) {
          obj.items.push({
            label: crmCustomModule,
            escape: false,
            command: () => {
              this.system = false;
              this.userm = false;
              this.marketplace = false;
              this.module = true;
              this.fsm = false;
              this.inventory = false;
              this.integration = false;
              this.misc = false;
              this.selectedWindow = 'crmCustomModule';
              this.componentName = CrmCustomComponent;
              this.buildConfigMenu();
            }
          });
        }

        if (this.leadMenuPermission) {
          obj.items.push({
            label: leadModule,
            escape: false,
            command: () => {
              this.system = false;
              this.userm = false;
              this.marketplace = false;
              this.module = true;
              this.fsm = false;
              this.inventory = false;
              this.integration = false;
              this.misc = false;
              this.selectedWindow = 'leadModule';
              this.componentName = CrmLeadsComponent;
              this.buildConfigMenu();
            }
          });
        }

        if (this.opportunityMenuPermission) {
          obj.items.push({
            label: opportunityModule,
            escape: false,
            command: () => {
              this.system = false;
              this.userm = false;
              this.marketplace = false;
              this.module = true;
              this.fsm = false;
              this.inventory = false;
              this.misc = false;
              this.integration = false;
              this.selectedWindow = 'opportunityModule';
              this.componentName = CrmOpportunityComponent;
              this.buildConfigMenu();
            }
          });
        }
     
        if (this.cSettingMenuPermission) {
          obj.items.push({
            label: cSettingModule,
            escape: false,
            command: () => {
              this.system = false;
              this.userm = false;
              this.marketplace = false;
              this.module = true;
              this.fsm = false;
              this.inventory = false;
              this.integration = false;
              this.misc = false;
              this.selectedWindow = 'cSettingModule';
              this.componentName = CSettingComponent;
              this.buildConfigMenu();
            }
          });
        }

      }

      if (obj.label == "FSM") {
        if (this.territoryMenuPermission) {
          obj.items.push({
            label: territoryManagement,
            escape: false,
            command: () => {
              this.system = false;
              this.userm = false;
              this.marketplace = false;
              this.module = false;
              this.fsm = true;
              this.inventory = false;
              this.misc = false;
              this.integration = false;
              this.selectedWindow = 'territoryManagement';
              this.componentName = FsmTerritoryComponent;
              this.buildConfigMenu();
            }
          })
        }
        
        if (this.questionnaireMenuPermission) {
            obj.items.push({
              label: Questionnaire,
              escape: false,
              command: () => {
                this.system = false;
                this.userm = false;
                this.marketplace = false;
                this.module = false;
                this.fsm = true;
                this.inventory = false;
                this.integration = false;
                this.selectedWindow = 'Questionnaire';
                this.componentName = CrmQuestionnaireComponent;
                this.buildConfigMenu();
              }
            })
        }

        if (this.fSettingMenuPermission) {
          obj.items.push({
            label: fSettingModule,
            escape: false,
            command: () => {
              this.system = false;
              this.userm = false;
              this.marketplace = false;
              this.module = false;
              this.fsm = true;
              this.inventory = false;
              this.integration = false;
              this.selectedWindow = 'fSettingModule';
              this.componentName = FSettingComponent;
              this.buildConfigMenu();
            }
          });
        }
      }
      if (obj.label == "Misc") {
        if (this.workspaceMenuPermission) {
          obj.items.push({
            label: workspaceModule,
            escape: false,
            command: () => {
              this.system = false;
              this.userm = false;
              this.marketplace = false;
              this.module = false;
              this.fsm = false;
              this.inventory = false;
              this.finance = false;
              this.integration = false;
              this.misc = true;
              this.selectedWindow = 'workspaceModule';
              this.componentName = ConfigurationWorkspaceComponent;
              this.buildConfigMenu();
            }
          })
        }
      }

      if (obj.label == "Inventory" || obj.label == "Inventaire" || obj.label == "存货") {

        if (this.productMenuPermission || this.locationMenuPermission || this.inventorySetupMenuPermission || this.quantityMenuPermission || this.orderMenuPermission || this.purchaseMenuPermission || this.customersMenuPermission || this.customMenuPermission || this.iSettingMenuPermission) {

          if (this.customMenuPermission) {
            obj.items.push({
              label: customModule,
              escape: false,
              command: () => {
                this.system = false;
                this.userm = false;
                this.marketplace = false;
                this.module = false;
                this.fsm = false;
                this.inventory = true;
                this.finance = false;
                this.integration = false;
                this.selectedWindow = 'customModule';
                this.componentName = CustomComponent;
                this.buildConfigMenu();
              }
            })
          }

          if (this.customRuleMenuPermission) {
            obj.items.push({
              label: customRuleModule,
              escape: false,
              command: () => {
                this.system = false;
                this.userm = false;
                this.marketplace = false;
                this.module = false;
                this.fsm = false;
                this.inventory = true;
                this.finance = false;
                this.integration = false;
                this.selectedWindow = 'customRuleModule';
                this.componentName = CustomRuleComponent;
                this.buildConfigMenu();
              }
            })
          }

          if (this.locationMenuPermission) {
            obj.items.push({
              label: locationModule,
              escape: false,
              command: () => {
                this.system = false;
                this.userm = false;
                this.marketplace = false;
                this.module = false;
                this.fsm = false;
                this.inventory = true;
                this.integration = false;
                this.finance = false;
                this.selectedWindow = 'locationModule';
                this.componentName = LocationComponent;
                this.buildConfigMenu();
              }
            })
          }

          if (this.pricebookMenuPermission) {
            obj.items.push({
              label: pricebookModule,
              escape: false,
              command: () => {
                this.system = false;
                this.userm = false;
                this.marketplace = false;
                this.module = false;
                this.fsm = false;
                this.inventory = true;
                this.finance = false;
                this.integration = false;
                this.selectedWindow = 'pricebookModule';
                this.componentName = PricebookComponent;
                this.buildConfigMenu();
              }
            })
          }

          if (this.productMenuPermission) {
            obj.items.push({
              label: productModule,
              escape: false,
              command: () => {
                this.system = false;
                this.userm = false;
                this.marketplace = false;
                this.module = false;
                this.fsm = false;
                this.inventory = true;
                this.finance = false;
                this.integration = false;
                this.selectedWindow = 'productModule';
                this.componentName = ProductComponent;
                this.buildConfigMenu();
              }
            })
          }

          if (this.purchaseMenuPermission) {
            obj.items.push({
              label: purchaseModule,
              escape: false,
              command: () => {
                this.system = false;
                this.userm = false;
                this.marketplace = false;
                this.module = false;
                this.fsm = false;
                this.inventory = true;
                this.finance = false;
                this.integration = false;
                this.selectedWindow = 'purchaseModule';
                this.componentName = PurchaseComponent;
                this.buildConfigMenu();
              }
            })
          }

          if (this.quantityMenuPermission) {
            obj.items.push({
              label: quantityModule,
              escape: false,
              command: () => {
                this.system = false;
                this.userm = false;
                this.marketplace = false;
                this.module = false;
                this.fsm = false;
                this.inventory = true;
                this.finance = false;
                this.integration = false;
                this.selectedWindow = 'quantityModule';
                this.componentName = InventoryQuantityComponent;
                this.buildConfigMenu();
              }
            })
          }

          if (this.orderMenuPermission) {
            obj.items.push({
              label: ordersModule,
              escape: false,
              command: () => {
                this.system = false;
                this.userm = false;
                this.marketplace = false;
                this.module = false;
                this.fsm = false;
                this.inventory = true;
                this.finance = false;
                this.integration = false;
                this.selectedWindow = 'ordersModule';
                this.componentName = OrdersComponent;
                this.buildConfigMenu();
              }
            })
          }

          if (this.inventorySetupMenuPermission) {
            obj.items.push({
              label: setupModule,
              escape: false,
              command: () => {
                this.system = false;
                this.userm = false;
                this.marketplace = false;
                this.module = false;
                this.fsm = false;
                this.inventory = true;
                this.integration = false;
                this.finance = false;
                this.selectedWindow = 'setupModule';
                this.componentName = SetupComponent;
                this.buildConfigMenu();
              }
            })
          }

          if (this.iSettingMenuPermission) {
            obj.items.push({
              label: iSettingModule,
              escape: false,
              command: () => {
                this.system = false;
                this.userm = false;
                this.marketplace = false;
                this.module = false;
                this.fsm = false;
                this.inventory = true;
                this.integration = false;
                this.finance = false;
                this.selectedWindow = 'iSettingModule';
                this.componentName = ISettingComponent;
                this.buildConfigMenu();
              }
            })
          }

        //   if (this.customersMenuPermission) {
        //     obj.items.push({
        //       label: customersModule,
        //       escape: false,
        //       command: () => {
        //         this.system = false;
        //         this.userm = false;
        //         this.marketplace = false;
        //         this.module = false;
        //         this.fsm = false;
        //         this.inventory = true;
        //         this.finance = false;
        //         this.integration = false;
        //         this.selectedWindow = 'customersModule';
        //         this.componentName = CustomersComponent;
        //         this.buildConfigMenu();
        //       }
        //     })
        //   }


        }
      }

      if (obj.label == "Finance" || obj.label == "La finance" || obj.label == "金融") {
        if (this.financeSetupMenuPermission) {
          obj.items.push({
            label: financeSetupModule,
            escape: false,
            command: () => {
              this.system = false;
              this.userm = false;
              this.marketplace = false;
              this.module = false;
              this.fsm = false;
              this.inventory = false;
              this.finance = true;
              this.integration = false;
              this.selectedWindow = 'financeSetupModule';
              this.componentName = FinanceSetupComponent;
              this.buildConfigMenu();
            }
          })
        }
      }

      if (obj.label == "Integrations" || obj.label == "Intégrations" || obj.label == "集成") {

        if (this.accountingMenuPermission || this.botsMenuPermission || this.calendarMenuPermission || this.emailMenuPermission || this.leadGenerationMenuPermission || this.proposalMenuPermission || this.ecommerceMenuPermission || this.smtpMenuPermission || this.posMenuPermission || this.shippingMenuPermission) {

          if (this.accountingMenuPermission) {
            obj.items.push({
              label: accountingModule,
              escape: false,
              command: () => {
                this.system = false;
                this.userm = false;
                this.marketplace = false;
                this.module = false;
                this.fsm = false;
                this.inventory = false;
                this.finance = false;
                this.integration = true;
                this.selectedWindow = 'accountingModule';
                this.componentName = AccountingComponent;
                this.buildConfigMenu();
              }
            })
          }

          if (this.botsMenuPermission) {
            obj.items.push({
              label: botsModule,
              escape: false,
              command: () => {
                this.system = false;
                this.userm = false;
                this.marketplace = false;
                this.module = false;
                this.fsm = false;
                this.finance = false;
                this.inventory = false;
                this.integration = true;
                this.selectedWindow = 'botsModule';
                this.componentName = BotsComponent;
                this.buildConfigMenu();
              }
            })
          }

          // if (this.calendarMenuPermission) {
          //   obj.items.push({
          //     label: calendarModule,
          //     escape: false,
          //     command: () => {
          //       this.system = false;
          //       this.userm = false;
          //       this.marketplace = false;
          //       this.module = false;
          //       this.fsm = false;
          //       this.inventory = false;
          //       this.finance = false;
          //       this.integration = true;
          //       this.selectedWindow = 'calendarModule';
          //       this.componentName = CalendarComponent;
          //       this.buildConfigMenu();
          //     }
          //   })
          // }

          if (this.emailMenuPermission) {
            obj.items.push({
              label: emailModule,
              escape: false,
              command: () => {
                this.system = false;
                this.userm = false;
                this.marketplace = false;
                this.module = false;
                this.fsm = false;
                this.inventory = false;
                this.finance = false;
                this.integration = true;
                this.selectedWindow = 'emailModule';
                this.componentName = EmailComponent;
                this.buildConfigMenu();
              }
            })
          }

          if (this.leadGenerationMenuPermission) {
            obj.items.push({
              label: leadGenerationModule,
              escape: false,
              command: () => {
                this.system = false;
                this.userm = false;
                this.marketplace = false;
                this.module = false;
                this.fsm = false;
                this.inventory = false;
                this.finance = false;
                this.integration = true;
                this.selectedWindow = 'leadGenerationModule';
                this.componentName = LeadGenerationComponent;
                this.buildConfigMenu();
              }
            })
          }

          if (this.posMenuPermission) {
            obj.items.push({
              label: posModule,
              escape: false,
              command: () => {
                this.system = false;
                this.userm = false;
                this.marketplace = false;
                this.module = false;
                this.fsm = false;
                this.inventory = false;
                this.finance = false;
                this.integration = true;
                this.selectedWindow = 'posModule';
                this.componentName = PosComponent;
                this.buildConfigMenu();
              }
            })
          }

          if (this.proposalMenuPermission) {
            obj.items.push({
              label: proposalModule,
              escape: false,
              command: () => {
                this.system = false;
                this.userm = false;
                this.marketplace = false;
                this.module = false;
                this.fsm = false;
                this.inventory = false;
                this.finance = false;
                this.integration = true;
                this.selectedWindow = 'proposalModule';
                this.componentName = ProposalComponent;
                this.buildConfigMenu();
              }
            })
          }

          if (this.ecommerceMenuPermission) {
            obj.items.push({
              label: ecommerceModule,
              escape: false,
              command: () => {
                this.system = false;
                this.userm = false;
                this.marketplace = false;
                this.module = false;
                this.fsm = false;
                this.inventory = false;
                this.finance = false;
                this.integration = true;
                this.selectedWindow = 'ecommerceModule';
                this.componentName = EcommerceComponent;
                this.buildConfigMenu();
              }
            })
          }

          if (this.smtpMenuPermission) {
            obj.items.push({
              label: smtpModule,
              escape: false,
              command: () => {
                this.system = false;
                this.userm = false;
                this.marketplace = false;
                this.module = false;
                this.fsm = false;
                this.inventory = false;
                this.finance = false;
                this.integration = true;
                this.selectedWindow = 'smtpModule';
                this.componentName = SmtpComponent;
                this.buildConfigMenu();
              }
            })
          }

          if (this.shippingMenuPermission) {
            obj.items.push({
              label: shipModule,
              escape: false,
              command: () => {
                this.system = false;
                this.userm = false;
                this.marketplace = false;
                this.module = false;
                this.fsm = false;
                this.inventory = false;
                this.finance = false;
                this.integration = true;
                this.selectedWindow = 'shipModule';
                this.componentName = ShippingComponent;
                this.buildConfigMenu();
              }
            })
          }

        }
      }

      if(obj.items?.length==0){
        obj.visible = false;
      }

      obj.visible = (obj.items?.length>0 || obj.label==company) as boolean;
    })
  }

  configTemp;
  configTempEmail;
  configTempPhone;
  configTempSocial;

  invalidData = false;
  industries = []
  revenue = []
  employeesMounts = []
  emailConfigLead;
  phoneConfigLead;
  socialConfigLead;


}
